module.exports = __webpack_public_path__ + "img/icon-navigation-expand-light.6b7c9681.svg";